import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TranslocoModule } from '@ngneat/transloco';

import { TelusNavbarComponent } from './navbar';
import { BarComponent } from './bar/bar';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
    TranslocoLocaleModule.forRoot(),
  ],
  declarations: [TelusNavbarComponent, BarComponent],
  exports: [TelusNavbarComponent],
})
export class TelusNavbarModule {}
